<div mat-dialog-title>{{ data.title }}</div>

<mat-dialog-content class="max-height">
  <div [ngClass]="isWarning ? 'warning' : 'hide'">
    <mat-icon> warning_amber </mat-icon>&nbsp;{{ 'auth0_warning' | translate }}
  </div>
  <div *amIfTablet>
    <mat-table #table [dataSource]="dataSource" matSort>
      <!-- Name/Status Column -->
      <ng-container matColumnDef="name">
        @if (!data.statusColumn) {
          <ng-container>
            <mat-header-cell *matHeaderCellDef class="name-label" mat-sort-header>
              {{ 'COMPANY_USERS.name' | translate }}
            </mat-header-cell>
          </ng-container>
        }
        @if (data.statusColumn) {
          <ng-container>
            <mat-header-cell *matHeaderCellDef class="name-label" mat-sort-header>
              {{ 'COMPANY_USERS.status' | translate }}
            </mat-header-cell>
          </ng-container>
        }
        <mat-cell *matCellDef="let user" class="name-column">
          @if (user.authID) {
            <div>
              {{ user.firstName }} {{ user.lastName }}
            </div>
          }
          @if (user.id && !user.isInvite) {
            <div>{{ user.name }}</div>
          }
          @if (user.isInvite) {
            <div class="pending-invite">
              {{ 'COMPANY_USERS.invite_pending' | translate }}
            </div>
          }
        </mat-cell>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef class="email-label">{{
          'COMPANY_USERS.email' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let user" class="email-column">{{
          user.email
        }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        class="branch-user-row"
        *matRowDef="let row; columns: displayedColumns"
      ></mat-row>
    </mat-table>

    @if (usersCount > 5) {
      <mat-paginator
        #paginator
        [length]="usersCount"
        [pageSize]="5"
      >
      </mat-paginator>
    }
  </div>

  <div *amIfMobile>
    <mat-list>
      @for (user of data.users; track user) {
        <mat-list-item>
          @if (user.id) {
            <h5 matLine>{{ user.name }}</h5>
          }
          @if (user.authID) {
            <h5 matLine>
              {{ user.firstName }} {{ user.lastName }}
            </h5>
          }
          <p matLine>{{ user.email }}</p>
        </mat-list-item>
      }
    </mat-list>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-dialog-close>
    {{ 'COMPANY_ADD_USERS.cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" [mat-dialog-close]="true">
    {{ buttonText }}
  </button>
</mat-dialog-actions>
